import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useLocation } from "react-router-dom";
import { getSettings } from "../lib/api";

export const AgeGate = () => {
  const location = useLocation();
  const [verified, setVerified] = useState(true);
  const [denied, setDenied] = useState(false);
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    setVerified(localStorage.getItem("age_verified") === "true");
    getSettings()
      .then((s) => setEnabled(s?.age_gate_enabled !== false))
      .catch(() => setEnabled(true));
  }, []);

  const confirm = () => {
    localStorage.setItem("age_verified", "true");
    setVerified(true);
  };

  if (!enabled || verified || location.pathname.startsWith("/admin")) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        className="fixed inset-0 z-[100] bg-[#0D110D] flex items-center justify-center px-6"
        data-testid="age-gate"
      >
        <div className="noise-overlay" />
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="relative z-10 text-center max-w-lg"
        >
          <img
            src="/logo-white.png"
            alt="Birrificio Vecchio Cinghiale"
            className="h-16 md:h-20 w-auto object-contain mx-auto mb-10"
          />
          <p className="font-mono-accent text-xs uppercase tracking-[0.3em] text-[#D47738] mb-6">
            Verifica dell'età
          </p>
          <h1 className="font-serif-display text-4xl md:text-6xl text-[#E8E2D2] leading-[0.95] mb-6">
            Hai compiuto <span className="italic text-[#D47738]">18 anni?</span>
          </h1>
          <p className="text-[#E8E2D2]/60 mb-10 leading-relaxed">
            Per accedere a questo sito devi essere maggiorenne. La vendita di
            alcolici ai minori è vietata dalla legge. Bevi responsabilmente.
          </p>

          {denied ? (
            <div className="border border-white/15 px-6 py-8" data-testid="age-denied">
              <p className="text-[#E8E2D2]/70">
                Ci dispiace, devi avere almeno 18 anni per accedere.
              </p>
            </div>
          ) : (
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button
                onClick={confirm}
                className="bg-[#D47738] text-[#0D110D] px-10 py-4 font-mono-accent text-xs uppercase tracking-[0.2em] hover:bg-[#E8E2D2] transition-colors duration-300"
                data-testid="age-confirm-btn"
              >
                Sì, ho 18+ anni
              </button>
              <button
                onClick={() => setDenied(true)}
                className="border border-white/20 text-[#E8E2D2] px-10 py-4 font-mono-accent text-xs uppercase tracking-[0.2em] hover:border-[#9E3C3C] hover:text-[#9E3C3C] transition-colors duration-300"
                data-testid="age-deny-btn"
              >
                No
              </button>
            </div>
          )}
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};
